export default "__VITE_PUBLIC_ASSET__332db8a2__"